var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.85 0 0 4.85 316.86 248.14)",
    style: {}
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 18,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -63.5,
    y: -21.42,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 20,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(0,180,255)"
    }
  }, "WINDY CITY"), /*#__PURE__*/React.createElement("tspan", {
    x: -63.5,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 24,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)"
    }
  }, "\u2736"), /*#__PURE__*/React.createElement("tspan", {
    x: -46.82,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 22,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: -29.68,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 24,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)"
    }
  }, "\u2736"), /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 20,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 2.58,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 24,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)"
    }
  }, "\u2736"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.26,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 33.29,
    y: 8.31,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 24,
      fontStyle: "normal",
      fontWeight: "bold",
      fill: "rgb(255,0,4)"
    }
  }, "\u2736"), /*#__PURE__*/React.createElement("tspan", {
    x: -63.5,
    y: 34.49,
    style: {
      strokeWidth: 1,
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 18,
      fontStyle: "normal",
      fill: "rgb(0,180,255)"
    }
  }, "CONFERENCE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitelogo);
export default __webpack_public_path__ + "static/media/sitelogo.3a9d24e5f745ebd5580db9c5d253242f.svg";
export { ForwardRef as ReactComponent };